import React, { useState, useEffect } from "react";
import {
  TextField,
  Typography,
  Box,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";

import dayjs from "dayjs";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useTasks, useTasksDispatch } from "../AppContext";
import { dispatchTYPE } from "../utils/constDispatch";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

export default function InputLeftInfo({ props, booking_id }) {
  const data_pdf = useTasks();
  const dispatch = useTasksDispatch();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const base_url_website = "https://booking.svietnamadventures.com";

  const link_draft =
    base_url_website + "/booking/draft/" + booking_id + "_" + data_pdf.secret;
  const link_detail =
    base_url_website + "/booking/detail/" + booking_id + "_" + data_pdf.secret;

  const copyToClipboard = (text, type) => {
    try {
      if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        showSnackbar(`${type} link copied to clipboard!`);
      } else {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            showSnackbar(`${type} link copied to clipboard!`);
          })
          .catch((err) => {
            console.error("Could not copy text: ", err);
            fallbackCopyTextToClipboard(text);
          });
      }
    } catch (err) {
      console.error("Clipboard error: ", err);
      showSnackbar("Failed to copy to clipboard", "error");
    }
  };

  const fallbackCopyTextToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;

    // Make the textarea out of viewport
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand("copy");
      const msg = successful ? "successful" : "unsuccessful";
      console.log("Fallback: Copying text was " + msg);
      if (!successful) {
        showSnackbar("Failed to copy to clipboard", "error");
      }
    } catch (err) {
      console.error("Fallback: Could not copy text: ", err);
      showSnackbar("Failed to copy to clipboard", "error");
    }

    document.body.removeChild(textArea);
  };

  const showSnackbar = (message, severity = "success") => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const sectionCard = {
    padding: 16,
    marginBottom: 16,
    borderRadius: 10,
    backgroundColor: "#fff",
    boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
    border: "1px solid #E0E0E0",
  };

  const sectionTitle = {
    fontWeight: 600,
    marginBottom: 12,
  };

  const fieldRow = {
    display: "flex",
    flexDirection: "row",
    gap: 8,
    marginBottom: 8,
  };

  return (
    <div>
      {/* Links Section */}
      <Box style={sectionCard}>
        <Typography variant="h6" style={sectionTitle}>
          Links
        </Typography>
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            padding: "8px 12px",
            backgroundColor: "#F5F9FF",
            borderRadius: 8,
            marginBottom: 8,
          }}
        >
          <Typography style={{ fontSize: 13, fontWeight: 600, color: "#555", minWidth: 100 }}>
            Draft booking
          </Typography>
          <a
            href={link_draft}
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontSize: 13, color: "#1976D2", flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
          >
            {link_draft.slice(0, 45)}...
          </a>
          <Button
            size="small"
            startIcon={<ContentCopyIcon sx={{ fontSize: 14 }} />}
            onClick={() => copyToClipboard(link_draft, "Draft")}
            sx={{
              ml: 1,
              borderRadius: "20px",
              textTransform: "none",
              fontSize: 12,
              minWidth: "auto",
            }}
          >
            Copy
          </Button>
        </Box>
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            padding: "8px 12px",
            backgroundColor: "#F5F9FF",
            borderRadius: 8,
          }}
        >
          <Typography style={{ fontSize: 13, fontWeight: 600, color: "#555", minWidth: 100 }}>
            Detail booking
          </Typography>
          <a
            href={link_detail}
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontSize: 13, color: "#1976D2", flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
          >
            {link_detail.slice(0, 45)}...
          </a>
          <Button
            size="small"
            startIcon={<ContentCopyIcon sx={{ fontSize: 14 }} />}
            onClick={() => copyToClipboard(link_detail, "Detail")}
            sx={{
              ml: 1,
              borderRadius: "20px",
              textTransform: "none",
              fontSize: 12,
              minWidth: "auto",
            }}
          >
            Copy
          </Button>
        </Box>
      </Box>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {/* Title Section */}
      <Box style={sectionCard}>
        <Typography variant="h6" style={sectionTitle}>
          Title
        </Typography>
        <Box style={fieldRow}>
          <TextField
            id="draft_title_pdf"
            label="Draft title"
            fullWidth
            size="small"
            variant="outlined"
            defaultValue={"TBA"}
            value={data_pdf.draft_title_pdf}
            onChange={(e) => {
              dispatch({
                type: dispatchTYPE.draft_title_pdf,
                value: e.target.value,
              });
            }}
          />
          <TextField
            id="detail_title_pdf"
            label="Detail title"
            fullWidth
            size="small"
            variant="outlined"
            defaultValue={"TBA"}
            value={data_pdf.detail_title_pdf}
            onChange={(e) => {
              dispatch({
                type: dispatchTYPE.detail_title_pdf,
                value: e.target.value,
              });
            }}
          />
        </Box>
      </Box>

      {/* Booking Information Section */}
      <Box style={sectionCard}>
        <Typography variant="h6" style={sectionTitle}>
          Booking Information
        </Typography>
        <Box style={fieldRow}>
          <TextField
            id="customer_email"
            label="Customer email"
            size="small"
            fullWidth
            variant="outlined"
            defaultValue={"TBA"}
            value={data_pdf.customer_email}
            onChange={(e) => {
              dispatch({
                type: dispatchTYPE.customer_email,
                value: e.target.value,
              });
            }}
          />
          <TextField
            id="customer_name"
            label="Customer name"
            size="small"
            fullWidth
            variant="outlined"
            value={data_pdf.customer_name}
            defaultValue={"TBA"}
            onChange={(e) => {
              dispatch({
                type: dispatchTYPE.customer_name,
                value: e.target.value,
              });
            }}
          />
          <TextField
            id="customer_cell"
            label="Customer cell"
            size="small"
            fullWidth
            variant="outlined"
            defaultValue={"TBA"}
            value={data_pdf.customer_cell}
            onChange={(e) => {
              dispatch({
                type: dispatchTYPE.customer_cell,
                value: e.target.value,
              });
            }}
          />
        </Box>
        <Box style={fieldRow}>
          <TextField
            id="booking_number"
            label="Booking number"
            size="small"
            fullWidth
            variant="outlined"
            defaultValue={"TBA"}
            value={data_pdf.booking_number}
            onChange={(e) => {
              dispatch({
                type: dispatchTYPE.booking_number,
                value: e.target.value,
              });
            }}
          />
          <TextField
            id="room_type"
            label="Room type"
            size="small"
            fullWidth
            variant="outlined"
            defaultValue={"TBA"}
            value={data_pdf.room_type}
            onChange={(e) => {
              dispatch({
                type: dispatchTYPE.room_type,
                value: e.target.value,
              });
            }}
          />
          <TextField
            id="prepare_by"
            label="Prepared by"
            size="small"
            fullWidth
            variant="outlined"
            defaultValue={"TBA"}
            value={data_pdf.prepared_by}
            onChange={(e) => {
              dispatch({
                type: dispatchTYPE.prepared_by,
                value: e.target.value,
              });
            }}
          />
        </Box>
      </Box>

      {/* Booking Detail Section */}
      <Box style={sectionCard}>
        <Typography variant="h6" style={sectionTitle}>
          Booking Detail
        </Typography>
        <Box style={fieldRow}>
          <TextField
            id="no_of_clients"
            label="No. of clients"
            size="small"
            fullWidth
            variant="outlined"
            defaultValue={"TBA"}
            value={data_pdf.no_of_client}
            onChange={(e) => {
              dispatch({
                type: dispatchTYPE.no_of_client,
                value: e.target.value,
              });
            }}
          />
          <TextField
            id="check_in"
            label="Check in"
            size="small"
            fullWidth
            variant="outlined"
            defaultValue={"TBA"}
            value={data_pdf.check_in}
            onChange={(e) => {
              dispatch({
                type: dispatchTYPE.check_in,
                value: e.target.value,
              });
            }}
          />
          <TextField
            id="check_out"
            label="Check out"
            size="small"
            fullWidth
            variant="outlined"
            defaultValue={"TBA"}
            value={data_pdf.check_out}
            onChange={(e) => {
              dispatch({
                type: dispatchTYPE.check_out,
                value: e.target.value,
              });
            }}
          />
          <TextField
            id="special_food_requirements"
            label="Special requirements"
            size="small"
            fullWidth
            variant="outlined"
            defaultValue={"TBA"}
            value={data_pdf.special_food_requirements}
            onChange={(e) => {
              dispatch({
                type: dispatchTYPE.special_food_requirements,
                value: e.target.value,
              });
            }}
          />
        </Box>
        <Box style={fieldRow}>
          <TextField
            fullWidth
            id="arrival_ariport"
            label="Arrival airport"
            size="small"
            variant="outlined"
            defaultValue={"TBA"}
            value={data_pdf.arrival_airport}
            onChange={(e) => {
              dispatch({
                type: dispatchTYPE.arrival_airport,
                value: e.target.value,
              });
            }}
          />
          <TextField
            id="arrival_flight"
            label="Arrival flight"
            size="small"
            fullWidth
            variant="outlined"
            defaultValue={"TBA"}
            value={data_pdf.arrival_flight}
            onChange={(e) => {
              dispatch({
                type: dispatchTYPE.arrival_flight,
                value: e.target.value,
              });
            }}
          />
        </Box>
        <Box style={fieldRow}>
          <TextField
            fullWidth
            id="departure_airport"
            label="Departure airport"
            size="small"
            variant="outlined"
            defaultValue={"TBA"}
            value={data_pdf.departure_airport}
            onChange={(e) => {
              dispatch({
                type: dispatchTYPE.departure_airport,
                value: e.target.value,
              });
            }}
          />
          <TextField
            id="departure_flight"
            label="Departure flight"
            size="small"
            fullWidth
            variant="outlined"
            defaultValue={"TBA"}
            value={data_pdf.departure_flight}
            onChange={(e) => {
              dispatch({
                type: dispatchTYPE.departure_flight,
                value: e.target.value,
              });
            }}
          />
        </Box>
        <Box style={fieldRow}>
          <TextField
            id="package"
            fullWidth
            label="Package"
            size="small"
            variant="outlined"
            defaultValue={"TBA"}
            value={data_pdf.package}
            onChange={(e) => {
              dispatch({
                type: dispatchTYPE.package,
                value: e.target.value,
              });
            }}
          />
        </Box>
        <Box style={fieldRow}>
          <TextField
            id="tour_type"
            label="Tour type"
            size="small"
            fullWidth
            variant="outlined"
            defaultValue={"TBA"}
            value={data_pdf.tour_type}
            onChange={(e) => {
              dispatch({
                type: dispatchTYPE.tour_type,
                value: e.target.value,
              });
            }}
          />
          <TextField
            id="tour_guide"
            fullWidth
            label="Tour guide"
            size="small"
            variant="outlined"
            defaultValue={"TBA"}
            value={data_pdf.tour_guide}
            onChange={(e) => {
              dispatch({
                type: dispatchTYPE.tour_guide,
                value: e.target.value,
              });
            }}
          />
        </Box>
      </Box>

      {/* Day Start Section */}
      <Box style={sectionCard}>
        <Typography variant="h6" style={sectionTitle}>
          Day Start
        </Typography>
        <Box style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              format="DD/MM/YYYY"
              value={dayjs(data_pdf.day_start, "DD/MM/YYYY")}
              label="Day start"
              slotProps={{ textField: { size: "small" } }}
              onChange={(e) => {
                dispatch({
                  type: dispatchTYPE.day_start,
                  value: dayjs(e).format("DD/MM/YYYY"),
                });
              }}
            />
          </LocalizationProvider>
          <Button
            size="small"
            variant="outlined"
            color="error"
            sx={{
              borderRadius: "20px",
              textTransform: "none",
              fontWeight: 500,
              fontSize: 13,
            }}
            onClick={() =>
              dispatch({ type: dispatchTYPE.day_start, value: null })
            }
          >
            Clear
          </Button>
        </Box>
      </Box>
    </div>
  );
}
